import { DOWNLOAD_PAYMENT_ATTACHMENTS } from "..";
import { apiInstance } from "../config/apiInstance";
import { AxiosResponse } from "axios";

export type DownloadPaymentAttachmentsRequest = {
  electronicDocumentId: number;
};

export type Attachment = {
  id: number;
  originalName: string;
  contentType: string;
  fileContentBase64: string;
};

export type DownloadPaymentAttachmentsResponse = {
  attachments: Attachment[];
};

export const downloadPaymentAttachments = async (
  data: DownloadPaymentAttachmentsRequest,
): Promise<AxiosResponse<DownloadPaymentAttachmentsResponse>> => {
  const response = await apiInstance.post<DownloadPaymentAttachmentsResponse>(
    DOWNLOAD_PAYMENT_ATTACHMENTS,
    data,
  );

  return response;
};
